export interface TariffResultTable {
    name: string;
    city: string;
    rating: string;
    selected: boolean;
}

export interface TariffResultTableState {
    sortBy: keyof TariffResultTable;
    sortDirection: 'neutral' | 'asc' | 'desc';
}
